import React from 'react';

import { useMediaQuery, useTheme } from '@mui/material';

export type ContextProps = {
  isMobile?: boolean
  isTablet?: boolean
  isDesktop?: boolean
  isApple: boolean
};

const defaultContext: ContextProps = {
  isMobile: undefined,
  isTablet: undefined,
  isDesktop: undefined,
  isApple: false,
};

export const LayoutContext = React.createContext(defaultContext);

export const LayoutProvider: React.FC<React.PropsWithChildren> = ({ children }) => {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const isApple = React.useMemo(() => /Mac|iPhone|iPad|iPod/.test(navigator.userAgent), []);

  return (
    <LayoutContext.Provider
      value={{
        isMobile,
        isTablet,
        isDesktop,
        isApple,
      }}
    >
      {children}
    </LayoutContext.Provider>
  );
};

export const LayoutConsumer = LayoutContext.Consumer;
